import { ColorScheme } from "@/models/ColorScheme"
export function getColorSchemeFromString(val: string): string {
  return (<any>ColorScheme)[val]
}
